const notificationActions = {
  DO_GET_NOTIFICATIONS: 'DO_GET_NOTIFICATIONS',
  DO_GET_NOTIFICATIONS_SUCCEEDED: 'DO_GET_NOTIFICATIONS_SUCCEEDED',
  DO_GET_NOTIFICATIONS_FAILED: 'DO_GET_NOTIFICATIONS_FAILED',

  DO_ADD_NOTIFICATION: 'DO_ADD_NOTIFICATION',

  DO_LOAD_ACTIONED: 'DO_LOAD_ACTIONED',
  DO_LOAD_ACTIONED_SUCCEEDED: 'DO_LOAD_ACTIONED_SUCCEEDED',
  DO_LOAD_ACTIONED_FAILED: 'DO_LOAD_ACTIONED_FAILED',

  DO_LOAD_UNACTIONED: 'DO_LOAD_UNACTIONED',
  DO_LOAD_UNACTIONED_SUCCEEDED: 'DO_LOAD_UNACTIONED_SUCCEEDED',
  DO_LOAD_UNACTIONED_FAILED: 'DO_LOAD_UNACTIONED_FAILED',

  DO_SEE_ALL_NOTIFICATIONS: 'DO_SEE_ALL_NOTIFICATIONS',
  DO_SEE_ALL_NOTIFICATIONS_SUCCEEDED: 'DO_SEE_ALL_NOTIFICATIONS_SUCCEEDED',
  DO_SEE_ALL_NOTIFICATIONS_FAILED: 'DO_SEE_ALL_NOTIFICATIONS_FAILED',

  DO_GET_COMPULSORY_NOTIFICATIONS: 'DO_GET_COMPULSORY_NOTIFICATIONS',
  DO_GET_COMPULSORY_NOTIFICATIONS_SUCCEEDED: 'DO_GET_COMPULSORY_NOTIFICATIONS_SUCCEEDED',
  DO_GET_COMPULSORY_NOTIFICATIONS_FAILED: 'DO_GET_COMPULSORY_NOTIFICATIONS_FAILED',
  
  DO_LOAD_COMPULSORY_NOTIFICATIONS: 'DO_LOAD_COMPULSORY_NOTIFICATIONS',
  DO_LOAD_COMPULSORY_NOTIFICATIONS_SUCCEEDED: 'DO_LOAD_COMPULSORY_NOTIFICATIONS_SUCCEEDED',
  DO_LOAD_COMPULSORY_NOTIFICATIONS_FAILED: 'DO_LOAD_COMPULSORY_NOTIFICATIONS_FAILED',

  DO_ACTION_AST_NOTIFICATION: 'DO_ACTION_AST_NOTIFICATION',
  DO_ACTION_AST_NOTIFICATION_SUCCEEDED: 'DO_ACTION_AST_NOTIFICATION_SUCCEEDED',
  DO_ACTION_AST_NOTIFICATION_FAILED: 'DO_ACTION_AST_NOTIFICATION_FAILED',

  doGetNotifications: () => ({
    type: notificationActions.DO_GET_NOTIFICATIONS,
  }),
  doGetNotificationsSucceeded: (response) => ({
    type: notificationActions.DO_GET_NOTIFICATIONS_SUCCEEDED,
    payload: response
  }),
  doGetNotificationsFailed: (response) => ({
    type: notificationActions.DO_GET_NOTIFICATIONS_FAILED,
    payload: response
  }),
  doAddNotification: (notification) => ({
    type: notificationActions.DO_ADD_NOTIFICATION,
    payload: notification
  }),

  doLoadActioned: (offset) => ({
    type: notificationActions.DO_LOAD_ACTIONED,
    payload: { offset }
  }),
  doLoadActionedSucceeded: (response) => ({
    type: notificationActions.DO_LOAD_ACTIONED_SUCCEEDED,
    payload: response
  }),
  doLoadActionedFailed: (response) => ({
    type: notificationActions.DO_LOAD_ACTIONED_FAILED,
    payload: response
  }),

  doLoadUnactioned: (offset) => ({
    type: notificationActions.DO_LOAD_UNACTIONED,
    payload: { offset }
  }),
  doLoadUnactionedSucceeded: (response) => ({
    type: notificationActions.DO_LOAD_UNACTIONED_SUCCEEDED,
    payload: response
  }),
  doLoadUnactionedFailed: (response) => ({
    type: notificationActions.DO_LOAD_UNACTIONED_FAILED,
    payload: response
  }),
  doSeeAllNotifications: () => ({
    type: notificationActions.DO_SEE_ALL_NOTIFICATIONS
  }),
  doSeeAllNotificationsSucceeded: (response) => ({
    type: notificationActions.DO_SEE_ALL_NOTIFICATIONS_SUCCEEDED,
    payload: response
  }),
  doSeeAllNotificationsFailed: (response) => ({
    type: notificationActions.DO_SEE_ALL_NOTIFICATIONS_FAILED,
    payload: response
  }),
  doGetCompulsoryNotifications: ({ offset }) => ({
    type: notificationActions.DO_GET_COMPULSORY_NOTIFICATIONS,
    payload: { offset }
  }),
  doGetCompulsoryNotificationsSucceeded: (response) => ({
    type: notificationActions.DO_GET_COMPULSORY_NOTIFICATIONS_SUCCEEDED,
    payload: response
  }),
  doGetCompulsoryNotificationsFailed: (response) => ({
    type: notificationActions.DO_GET_COMPULSORY_NOTIFICATIONS_FAILED,
    payload: response
  }),
  doLoadCompulsoryNotifications: (offset) => ({
    type: notificationActions.DO_LOAD_COMPULSORY_NOTIFICATIONS,
    payload: { offset }
  }),
  doLoadCompulsoryNotificationsSucceeded: (response) => ({
    type: notificationActions.DO_LOAD_COMPULSORY_NOTIFICATIONS_SUCCEEDED,
    payload: response
  }),
  doLoadCompulsoryNotificationsFailed: (response) => ({
    type: notificationActions.DO_LOAD_COMPULSORY_NOTIFICATIONS_FAILED,
    payload: response
  }),
  doActionAstNotification: (hash) => ({
    type: notificationActions.DO_ACTION_AST_NOTIFICATION,
    payload: hash
  }),
}

export default notificationActions;


// WEBPACK FOOTER //
// ./src/redux/notifications/actions.js